import { apiFunction } from "../../apiCall/function"

export const getChapter = async (code) => {
  return await apiFunction("form/question-bank/" + code, "get", {}, false, 'body')
}